import { Controller, useForm } from "react-hook-form";
import _ from "@lodash";
import TextField from "@mui/material/TextField";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import React from "react";
import Box from "@mui/material/Box";
import SearchIcon from "@mui/icons-material/Search";
import BackIcon from "@mui/icons-material/Backspace";
import { FormControl, InputLabel, Select, IconButton, Card, MenuItem } from "@mui/material";
import { useTranslation } from "react-i18next";



function YouthTimeSheetFilter() {
 const { t } = useTranslation("youthTimeSheetPage"); 

  return (
    <>
<Card variant="outlined" className="m-24 mb-0">
        <div className="flex content-between justify-start m-24">
        <div className="w-1/3 mt-16 mr-16">
            <Box sx={{ minWidth: 120 }} >
              <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label">
                  {t("PROGRAM")}
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Week"
                  
                >
                  <MenuItem value={"1"}>Summer Youth Employment Program </MenuItem>
                  <MenuItem value={"2"}>In-School Youth Program</MenuItem>
                  <MenuItem value={"3"}>Youth Leadership Program</MenuItem>
                  <MenuItem value={"4"}>Pathways for Youth Adults Program</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </div>

          <div className="w-1/3 mt-16 mr-16">
            <Box sx={{ minWidth: 120 }} >
              <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label">
                  {t("COMPANY")}
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  
                  
                >
                  <MenuItem value={"1"}>Codice</MenuItem>
                  <MenuItem value={"2"}>ABC Pharma</MenuItem>
                  <MenuItem value={"3"}>Worksite 3</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </div>



          <div className="mt-20">
            <IconButton
              color="primary"
              aria-label="upload picture"
              component="label"
            >
              <SearchIcon />
            </IconButton>
          </div>
          <div className="mt-20  mr-1">
            <IconButton
              color="primary"
              aria-label="upload picture"
              component="label"
            >
              <BackIcon />
            </IconButton>
          </div>
        </div>
      </Card>
    </>
  );
}

export default YouthTimeSheetFilter;
